import { FC, memo } from 'react';

import { ImageData } from '../VariationOne';
import { getWatermarkTag } from '../shared';
import SharedUploadedImageRow from '../shared/UploadedImageRow';
import SettingsModal from './SettingsModal';

interface Props {
  image: ImageData;
  imageIndex: number;
  setImages: React.Dispatch<React.SetStateAction<ImageData[]>>;
  hasText?: boolean;
}

const VariationFullImageAndBoxTriviaUploadedImageRow: FC<Props> = ({
  image,
  imageIndex,
  setImages,
  hasText,
}) => {
  const settingsApplied =
    getWatermarkTag(image) !== 'none' ||
    Boolean(image.textPosition !== 'bottom');

  return (
    <SharedUploadedImageRow
      image={image}
      imageIndex={imageIndex}
      setImages={setImages as any}
      showSettings
      showText={false}
      settingsApplied={settingsApplied}
      fullWidth
      aspectRatio={1200 / 630}
      settingsModal={
        <SettingsModal
          image={image}
          imageIndex={imageIndex}
          setImages={setImages as any}
          onClose={() => {}}
        />
      }
    />
  );
};

export default memo(VariationFullImageAndBoxTriviaUploadedImageRow);
